import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Cocacola from "../../../assets/cocacola.png";
import Giveaway from "../../../assets/giveaway.png";
import { Image } from "antd";
import classes from "./NewsDetails.module.css";
import Slider1 from "../../../assets/slider1.png";
import Slider2 from "../../../assets/slider2.png";
import Slider3 from "../../../assets/slider3.png";
import Slider4 from "../../../assets/slider4.png";
import FirstNews from "../../../assets/partnersBackground.jpg";
import NewsDiv from "./NewsDiv";

const NewsDetails = () => {
	const newsItems = [
		{
			id: 1,
			title: "The Tech Revolution in Logistics: A Glimpse into the Future",
			description:
				"Commitment to protecting what you hold dear is a testament to the transformative power of insurance.",
			content: "Full content of the news article goes here...",
			image: FirstNews,
		},
		{
			id: "2",
			title: "Another News Title",
			description: "Description for another news item.",
			image: FirstNews,
		},
		{
			id: "3",
			title: "Yet Another News Title",
			description: "Description for yet another news item.",
			image: FirstNews,
		},
	];

	const location = useLocation();
	const { id } = location.state as { id: number; title: string };

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const notification = newsItems.find((item: any) => item.id === id);

	return (
		<div className={classes.bossContainer}>
			<div
				className={classes.mainContainer}
				style={{
					backgroundImage: `url(${notification?.image})`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}
			>
				<div className={classes.textContainer}>
					{notification && (
						<>
							<h1 className={classes.h1Text}>
								{notification.title}
							</h1>
							<p className={classes.pText}>
								{notification.description}
							</p>
						</>
					)}
				</div>
			</div>
			{/* <NewsDiv /> */}
		</div>
	);
};

export default NewsDetails;
